import api from "./api";

const UomService = {
  create: async (data) => {
    const response = await api.post("/uom/save", data);
    return response.data;
  },

 getAll: async (pageNumber = 1, noOfRows = 20) => {
  const response = await api.get("/uom/getAll", {
    params: { pageNumber, noOfRows },
  });

  return response.data;
},


  getById: async (id) => {
    const response = await api.get(`/uom/getById/${id}`);
    return response.data;
  },

  getActive: async () => {
    const response = await api.get("/uom/getActive/list");
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/uom/update/${id}`, data);
    return response.data;
  },

  updateStatus: async (id, status) => {
      const res = await api.put(`/uom/updateStatus/${id}`, { status });
      return res.data;
    },

  delete: async (id) => {
    const response = await api.delete(`/uom/${id}`);
    return response.data;
  },
};

export default UomService;
